import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { DangerNotify } from "../svg/Index";

const Input: React.FC<IInputComponentProps> = (props) => {
  const { classNameWrapper, className, onChange, value, name, id, placeholder, label, withChecked, width, maxLength, error, onBlur, disabled, type, inputRef = null, onKeyDown } = props;
  const [valueState, setValueState] = useState<string | number>("");
  const [showIcon, setShowIcon] = useState(false);

  useEffect(() => {
    if (withChecked) {
      setShowIcon(!!value && !!withChecked);
    }
  }, [value]);
  const handleChangeValue = (value: string) => {
    setValueState(value);
    if (onChange) {
      onChange(value);
    }
    if (withChecked) {
      setShowIcon(!!value && !!withChecked);
    }
  };
  const handleOutFocus = (eventValue: string) => {
    eventValue = eventValue.trim();
    if (onBlur) {
      onBlur(eventValue);
    }
  };
  return (
    <div className={`component__input  ${classNameWrapper}`}>
      <TextField
        inputRef={inputRef}
        type={type}
        name={name}
        label={label}
        placeholder={placeholder}
        onKeyDown={onKeyDown}
        id={id}
        fullWidth
        size="small"
        slotProps={{
          input: {
            startAdornment: <></>,
          },
          htmlInput: {
            maxLength: maxLength,
          },
        }}
        error={!!error}
        style={{
          width: width,
        }}
        className={` ${className}`}
        inputProps={{ maxLength: maxLength }}
        sx={{
          width: "100%",
          "& .MuiInputBase-root": {
            paddingLeft: "0px",
          },
          "& .MuiInputBase-input": {
            paddingLeft: "14px",
          },
          "& .MuiOutlinedInput-root": {
            "&::after": {
              content: '""',
              display: !error && showIcon ? "block" : "none",
              position: "absolute",
              right: 10,
              top: "50%",
              transform: "translateY(-50%)",
              width: 14,
              height: 10,
              backgroundImage: 'url("/images/ico_check.svg")',
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
              pointerEvents: "none",
            },
          },
        }}
        value={value}
        onChange={(e) => handleChangeValue(e.target.value)}
        onBlur={(event) => handleOutFocus(event.target.value)}
        disabled={disabled}
      />
      {error ? (
        <div className="invalid-danger">
          <span>
            <DangerNotify />
          </span>
          <span>{error}</span>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default Input;